export const GET_ANSWER_INBOX_PROCESS_STATEMENT_COUNT_SUCCESS = 'GET_ANSWER_INBOX_PROCESS_STATEMENT_COUNT_SUCCESS';

export const getAnswerInboxProcessStatementCountSuccess = ({ inboxCount, request }) => ({
    type: GET_ANSWER_INBOX_PROCESS_STATEMENT_COUNT_SUCCESS,
    payload: { inboxCount },
    meta: {
        request,
    }
});
